/**
 * Every message that picks its form by a number, and the parameter it picks by.
 *
 * ── WHY THIS LIST EXISTS AT ALL ─────────────────────────────────────────────
 * The hand-rolled renderer this façade replaced refused a plural whose count
 * was not a finite number: `{ retryAfterSeconds: "soon" }` rendered the
 * fallback sentence, not "Try again in soon seconds." Paraglide compiles a
 * plural to `i?.count === 1 || i?.count === "1"` and interpolates whatever
 * arrived in the `*` branch, so without this list the façade would render the
 * garbage the old one refused. The compiled module carries no runtime
 * metadata to read the selectors from, and adding a compile step to
 * `@repo/i18n` to emit them would be a second build for nine entries.
 *
 * ── WHAT KEEPS IT TRUE ──────────────────────────────────────────────────────
 * `__tests__/plural-selectors.test.ts` parses every message file under
 * `packages/shared/i18n/messages/**` and fails when a message declares a
 * selector this list does not name, or this list names one no message
 * declares. Adding a plural to a namespace therefore fails that test until the
 * line is added here — which is the whole point.
 *
 * Every selector listed is treated as a NUMBER. A non-numeric selector (a
 * gender, an enum) would need its own rule; there is none today.
 */
export const PLURAL_SELECTORS = {
    "catalog.result_count": ["count"],
    "days.fixed_days_trimmed": ["count"],
    "onboarding.fixed_weekdays.too_many": ["count"],
    "onboarding.parq.some_yes": ["count"],
    "otp.too_many_attempts": ["retryAfterSeconds"],
    "today.session_meta": ["count"],
    "week.day_meta": ["count"],
    "week.draft_row_subtitle": ["count"],
    "week.rebuild.changed": ["count"],
};
//# sourceMappingURL=plural-selectors.js.map